import React from 'react';
interface MetricCardProps {
  value: string;
  label: string;
  className?: string;
}
export function MetricCard({
  value,
  label,
  className = ''
}: MetricCardProps) {
  return <div className={`bg-white rounded-lg shadow-sm p-6 text-center ${className}`} data-id="element-62">
      <div className="text-3xl md:text-4xl font-display font-bold text-coral-dark mb-2" data-id="element-63">
        {value}
      </div>
      <div className="text-sm text-navy" data-id="element-64">{label}</div>
    </div>;
}